import { connect } from 'react-redux';
import { fetchProductDetails } from '../productDetailsActions';
import ColorSwatches from './colorSwatches';

const mapStateToProps = ({ detailsPage }) => ({
  colorSwatches: detailsPage.colorSwatches,
  actualColorSwatch: detailsPage.actualColorSwatch,
  loadedProduct: detailsPage.loadedProduct,
});

const mapDispatchToProps = dispatch => ({
  fetchProductDetails(url) {
    dispatch(fetchProductDetails(url));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ColorSwatches);
